import React, { useState } from "react";
import CustomModal from "../../../../Components/modals/CustomModal";
import { LoadingButton } from "../../../../Components/header/form";
import { uploadAttachmentApi } from "../../../../services/message";
import { toastMessage } from "../../../../utils/toastMessage";

const FileUpload = ({
  show,
  close,
  file,
  setFile,
  attachment,
  setAttachment,
  sendDataHandler = () => { },
}) => {
  const [imageButtonLoader, setImageButtonLoader] = useState(false);

  //-------------file-handler-----------------
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const isImage = file.type.startsWith("image/");
      const isPDF = file.type === "application/pdf";

      if (isImage || isPDF) {
        setFile({ attachment: file });
      } else {
        toastMessage(
          "Please upload a valid file (image or PDF only).",
          "error",
          "uploadAttachment"
        );
        e.target.value = null;
        setFile({ attachment: "" });
      }
    }
  };

  //------------API-to-image--convert-to-url----------------
  const uploadAttachment = async () => {
    if (!file?.attachment) {
      return toastMessage("please upload image", "error", "selectMedia");
    }
    try {
      setImageButtonLoader(true);
      const formData = new FormData();
      formData.append("attachments", file?.attachment);

      const { data } = await uploadAttachmentApi(formData);
      const { success, message, data: res } = data;
      if (success) {
        console.log('data success', res)
        const data = res?.[0]
        setAttachment({
          attachment: data?.key,
          url: data?.url,
          type: "MEDIA",
          name: data?.name,
          size: data?.size,
        });
        // const uploadedUrl = res?.[0]?.url || '';
        // const fileExtension = uploadedUrl.split('.').pop().toLowerCase();

        // const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension);
        // const isPDF = fileExtension === 'pdf';

        // setAttachment({
        //     attachment: res?.[0]?.key,
        //     url: uploadedUrl,
        //     type: isImage ? "MEDIA" : isPDF ? "DOCUMENT" : "UNKNOWN"
        // });

        // sendDataHandler({
        //     attachment: res?.[0]?.key,
        //     url: res?.[0]?.url,
        //     type: "MEDIA"
        // })
        modalClose();
      }
      toastMessage(message, success ? "success" : "error", "addGroupHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setImageButtonLoader(false);
    }
  };

  //--------modal-close-----------
  const modalClose = () => {
    close();
    setFile({ attachment: "" });
  };
  return (

    <CustomModal
      show={show}
      handleClose={modalClose}
      className="input_image_model"
    >
      <input
        type="file"
        id="image_file"
        accept="image/*,application/pdf"
        onChange={handleFileChange}
        className="input_select_img form-control"
      />

      {/* {file.attachment?.name && <img src={URL.createObjectURL(file.attachment)} alt="" />} */}

      {file.attachment && (
        <>
          {file.attachment.type.startsWith("image/") ? (
            <img
              className="w-100 h-50"
              src={URL.createObjectURL(file.attachment)}
              alt="preview"
              style={{
                maxWidth: "200px",
                borderRadius: "8px",
                marginTop: "10px",
                objectFit: "fill"
              }}
            />

          ) : file.attachment.type === "application/pdf" ? (
            <iframe
              className="w-100 h-50"
              src={URL.createObjectURL(file.attachment)}
              title="PDF Preview"
              style={{
                width: "100%",
                height: "400px",
                marginTop: "10px",
                border: "1px solid #ccc",
              }}
            />
          ) : null}
        </>
      )}

      <LoadingButton

        loading={imageButtonLoader}
        className="button file_submit_btn"
        onClick={uploadAttachment}

      >
        Submit
      </LoadingButton>


    </CustomModal>

  );
};

export default FileUpload;
